import { post, get } from '@/server/axios'
// 公告发布权限配置列表
function page_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/page`,
    params,
    option
  ).then(response => response)
}
// 公告发布权限配置详情
function detail_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/detail`,
    params,
    option
  ).then(response => response)
}
// 新增公告发布权限配置
function add_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/add`,
    params,
    option
  ).then(response => response)
}
// 更新公告发布权限配置
function update_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/update`,
    params,
    option
  ).then(response => response)
}
// 查询当前登陆人发布范围权限
function get_user_scope_get(params, option) {
  return get(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/get-user-scope`,
    params,
    option
  ).then(response => response)
}
// 作废公告发布权限配置
function cancellation_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/cancellation`,
    params,
    option
  ).then(response => response)
}
// 生效公告发布权限配置
function take_effect_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_PUBLISH_PERMISSION_CONFIG}/announcement-publish-permission-config/take-effect`,
    params,
    option
  ).then(response => response)
}
export const announcementPublishPermissionConfig = {
  page_post,
  detail_post,
  add_post,
  update_post,
  get_user_scope_get,
  cancellation_post,
  take_effect_post
}
